"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useViewModel = void 0;
const reactiveState_1 = require("../reactiveState");
const features_1 = require("../features");
const useViewModel = (controller) => {
    if (!('getViewModel' in controller) || typeof controller.getViewModel !== 'function') {
        const errorMessage = 'You forgot to add @observableController decorator to your controller';
        features_1.Log.error(errorMessage);
        throw new Error(errorMessage);
    }
    return (0, reactiveState_1.useReactiveState)(controller.getViewModel())[0];
};
exports.useViewModel = useViewModel;
//# sourceMappingURL=useViewModel.js.map